import { Badge } from "react-bootstrap";

// Status badge configuration
const statusConfig = {
  eligible: { bg: "badge-subtle-success", text: "text-success" },
  ineligible: { bg: "badge-subtle-danger", text: "text-danger" },
  invalid: { bg: "badge-subtle-warning", text: "text-warning" },
  default: { bg: "badge-subtle-secondary", text: "text-secondary" },
};

// Reusable components
export const StatusBadge = ({ status }) => {
  const { bg, text } =
    statusConfig[status?.toLowerCase()] || statusConfig.default;
  return (
    <span className={`badge ${bg} rounded-2 fs-11 fw-500 px-3 py-1 ${text}`}>
      {(status || "No Response").toUpperCase()}
    </span>
  );
};

export const BooleanBadge = ({ value }) => (
  <Badge bg={Number(value) ? "success" : "danger"}>
    {Number(value) ? "Yes" : "No"}
  </Badge>
);
